import React, { useEffect, useState } from 'react';
import collaborativeIcon from "../../../../Assets/Images/CollabrativeIcon.png";
import visionary from "../../../../Assets/Images/VISIONARY.png";
import strategic from "../../../../Assets/Images/StrategicIcon.png";
import performance from "../../../../Assets/Images/PerformaceIcon.png";
import Heart from "../../../../Assets/Images/HEART.png";
import Soul from "../../../../Assets/Images/SOUL.png";
import Mind from "../../../../Assets/Images/MIND.png";
import Strength from "../../../../Assets/Images/STRENGTH.png";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";

const initialData = [
  { quadrant: 'STRATEGIC', no: 4, question: 'My most important responsibility is the long-term stewardship of organizational assets.', score: 2 },
  { quadrant: 'VISIONARY', no: 4, question: 'I am always looking to place a particular project within the context of the larger purpose.', score: 3 },
  { quadrant: 'COLLABORATIVE', no: 4, question: 'I believe relationships of trust are essential to create a successful organization.', score: 4 },
  { quadrant: 'PERFORMANCE', no: 4, question: 'I like the challenge of working in a high-performance leadership team.', score: 1 },
  { quadrant: 'PERFORMANCE', no: 5, question: 'I believe great execution is primary.', score: 1 },
  { quadrant: 'VISIONARY', no: 5, question: 'I believe sharing inspirational stories should be an important part of our culture.', score: 3 },
  { quadrant: 'STRATEGIC', no: 5, question: 'I believe effective strategy is primary.', score: 2 },
  { quadrant: 'COLLABORATIVE', no: 5, question: 'I believe developing a healthy culture is a very high value of my leadership.', score: 4 },
  { quadrant: 'VISIONARY', no: 6, question: 'I am motivated by creativity.', score: 3 },
  { quadrant: 'PERFORMANCE', no: 6, question: 'I am motivated to push my team to win.', score: 1 },
  { quadrant: 'COLLABORATIVE', no: 6, question: 'I am motivated to help my team connect more deeply with each other.', score: 4 },
  { quadrant: 'STRATEGIC', no: 6, question: 'I am motivated by developing a clear strategic plan.', score: 2 },
  { quadrant: 'STRATEGIC', no: 7, question: 'I believe strategic thinking is the main contributor of success.', score: 2 },
  { quadrant: 'PERFORMANCE', no: 7, question: 'I have found success by outworking other people.', score: 1 },
  { quadrant: 'COLLABORATIVE', no: 7, question: 'I find satisfaction from developing a collaborative leadership culture.', score: 4 },
  { quadrant: 'VISIONARY', no: 7, question: 'I believe success is contingent on having a clear vision.', score: 3 },
]

const Logo = (quadrant) => {
  switch (quadrant) {
    case 'COLLABORATIVE':
      return <img src={collaborativeIcon} alt="Collaborative" className="logo" />;
    case 'VISIONARY':
      return <img src={visionary} alt="Visionary" className="logo" />;
    case 'STRATEGIC':
      return <img src={strategic} alt="Strategic" className="logo" />;
    case 'PERFORMANCE':
      return <img src={performance} alt="Performance" className="logo" />;
    case 'HEART':
      return <img src={Heart} alt="Heart" className="logo" />;
    case 'SOUL':
      return <img src={Soul} alt="Soul" className="logo" />;
    case 'MIND':
      return <img src={Mind} alt="Mind" className="logo" />;
    case 'STRENGTH':
      return <img src={Strength} alt="Strength" className="logo" />;
    default:
      return null;
  }
};

const truncateText = (text, limit) => {
  if (text.length <= limit) return text;
  return text.substring(0, text.lastIndexOf(" ", limit)) + "...";
};

const ItemTwo = ({ apiData, pageNumber }) => {
  const [dynamicData, setDynamicData] = useState([...initialData]);


  useEffect(() => {
    // Keep the same data processing logic but for items 21-40
    if (!apiData || !apiData.variables || !apiData.variables.length) {
      setDynamicData(initialData);
      return;
    }

    // Same logic as Item.jsx for processing data
    const questions = [];

    apiData.variables.forEach(item => {
      const match = item.variable?.match(/^ls(\d+)_self_pass([12])$/);
      if (!match) return;

      const rawNo = parseInt(match[1]);
      const passType = match[2];

      let actualScore;
      let actualQuestionNo;

      if (rawNo >= 1 && rawNo <= 10) {
        actualScore = passType === "1" ? 4 : 1;
        actualQuestionNo = rawNo;
      } else if (rawNo >= 11 && rawNo <= 20) {
        actualScore = passType === "1" ? 3 : 2;
        actualQuestionNo = rawNo - 10;
      } else {
        return;
      }

      questions.push({
        questionNo: actualQuestionNo,
        rawNo: rawNo,
        passType,
        actualScore,
        updatedAt: item.updatedAt,
        variable: item.variable,
        score: item.score,
      });
    });

    const latestScoresMap = new Map();


    questions.forEach(question => {
      const key = `${question.questionNo}_${question.score}`;
      const existing = latestScoresMap.get(key);

      if (!existing || question.rawNo > 10) {
        latestScoresMap.set(key, question);
      }
    });

    const updatedData = initialData.map(item => {
      const matchingQuestion = Array.from(latestScoresMap.values())
        .find(q => q.questionNo === item.no && q.score === item.score);

      return {
        ...item,
        score: matchingQuestion ? matchingQuestion.actualScore : '-'
      };
    });

    setDynamicData(updatedData);
  }, [apiData]);


  console.log(dynamicData)

  const categoryMeta = [
    { label: "COMMITMENTS", color: "#394554" },
    { label: "BELIEFS", color: "#666666" },
    { label: "MOTIVATIONS", color: "#394554" },
    { label: "DRIVERS", color: "#666666" }
  ];

  const categories = categoryMeta.map((meta, idx) => ({
    ...meta,
    rows: dynamicData.slice(idx * 4, idx * 4 + 4),
  }));


  return (
    <div>
      <HeaderPreview apiData={apiData} />
      <div className="page">
        <div className="content">
          <div className="table">
            <table>
              <thead>
                <tr className="tableHeader">
                  <th className="cellBandHeader"></th>
                  <th className="cellIndex">#</th>
                  <th className="cellQuadrant" style={{ paddingLeft: "0", width: "65px" }}>Quadrant</th>
                  <th className="cellLogo"></th>
                  <th className="cellQuestion-self">Question</th>
                  <th className="cellScore" style={{ padding: "0 5px" }}>Score</th>
                </tr>
              </thead>
              <tbody>
                {categories.map((category, catIdx) =>
                  category.rows.map((item, rowIdx) => {
                    const rowNumber = 13 + catIdx * 4 + rowIdx;
                    const isCategoryStart = rowIdx === 0;
                    const isCategoryEnd = rowIdx === category.rows.length - 1;
                    const rowClass = `tableRow ${isCategoryStart ? 'categoryStart' : ''} ${isCategoryEnd ? 'categoryEnd' : ''}`.trim();

                    return (
                      <tr key={`${category.label}-${rowIdx}`} className={rowClass}>
                        {isCategoryStart && (
                          <td
                            className="cellBand categoryBand"
                            rowSpan={category.rows.length || 4}
                            style={{ backgroundColor: category.color }}
                          >
                            <span className="bandLabel">{category.label}</span>
                          </td>
                        )}
                        <td className="cellIndex">{rowNumber}.</td>
                        <td className="cellQuadrant" style={{ width: "75px", padding: "0" }}>{item.quadrant}</td>
                        <td className="" style={{ width: "14px", height: "100%" }}>{Logo(item.quadrant)}</td>
                        <td className="cellQuestion-self">{item.question}</td>
                        <td className="cellScore">{typeof item.score === 'number' ? item.score : '-'}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} />
    </div>
  );
};

export default ItemTwo;
